function View(){
    return(
        <div>
            <input type="submit" value="view more" className="Viewmore"></input>
        </div>
    );
}
export default View;